<template>
  <a-spin :spinning="AuthLayoutSpinning" size="large">
    <div class="tw-flex tw-flex-col tw-h-screen tw-w-screen">
      <div class="tw-flex tw-flex-1 tw-items-center tw-justify-center">
        <div class="tw-flex tw-h-auto tw-w-4/6 tw-rounded-3xl tw-overflow-hidden tw-animate-fade-in-up">
          <div class="tw-flex tw-flex-1 tw-flex-col tw-bg-blue-500 tw-text-white tw-p-12 tw-justify-between tw-bg-rays-background tw-hidden lg:tw-flex">
            <router-link slot="brand" class="navbar-brand" to="/">
              <img src='@/assets/barter-full.png' alt='logobarter' class="tw-img-white">
            </router-link>
            <div>
                <h1 class="tw-text-white tw-text-4xl">Barter XI.<br>A Powerful<br>Retail Solution.</h1>
              <p>Designed to optimize your<br>business operations.</p>
            </div>
          </div>
          <div class="tw-flex-1 tw-bg-white">
            <div v-if="notification && notification.type" class="tw-absolute tw-p-4 tw-z-10 tw-w-fill">
              <tw-base-alert :key="notification.message" :icon="notification.icon" :type="notification.type" :dismissible="true" class="tw-text-sm tw-animate-fade-in-up">
                <div>
                  <span class="tw-inline tw-w-full">{{ notification.message }}</span>
                  <span class="tw-inline tw-w-full" v-if="notification.clearExistingSession && typeof notification.clearExistingSession === 'function'">
                    Click <a @click="notification.clearExistingSession"><u>here</u></a> to remove
                    existing session
                  </span>
                </div>
              </tw-base-alert>
            </div>
            <router-view 
              @handleNotifications="handleNotifications"
              @changeAuthLayoutSpinning="changeAuthLayoutSpinning"
              class="tw-px-12 tw-py-6 tw-h-full tw-overflow-y-auto"
            />
          </div>
        </div>
      </div>
      <div class="tw-text-center tw-text-slate-500 tw-p-4 tw-text-xs">
        &copy; {{year}}
        <a href="https://www.iripple.com" target="_blank">iRipple, Inc.</a>
      </div>
    </div>
  </a-spin>
</template>

<script>
  export default {
    name: 'tw-auth-layout',
    data() {
      return {
        year: new Date().getFullYear(),
        showMenu: false,
        AuthLayoutSpinning:false,
        notification: null
      }
    },
    methods: {
      changeAuthLayoutSpinning (status) {
        this.AuthLayoutSpinning = status;
      },
      handleNotifications (notification) {
        this.notification = {}
        setTimeout(() => {
          this.notification = notification
        }, 100)
      },
      setViewportMetaTag() {
        const meta = document.createElement('meta');
        meta.name = 'viewport';
        meta.content = 'width=device-width, initial-scale=1, maximum-scale=5, user-scalable=yes';
        document.head.appendChild(meta);
      },
      removeMetaTag() {
        const meta = document.querySelector('meta[name="viewport"]');
        if (meta) document.head.removeChild(meta);
      }
    },
    mounted() {
      this.setViewportMetaTag();
      window.addEventListener('beforeunload', this.removeMetaTag);
    },
    beforeDestroy() {
      window.removeEventListener('beforeunload', this.removeMetaTag);
      this.removeMetaTag();
    },
  }
</script>